export const visit = (vm, at) => {
at({ "es-mx": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Hubo un problema de conexi\xF3n de red.", "message": "Comprueba la conexi\xF3n y vuelve a intentarlo.", "button": "Int\xE9ntalo de nuevo" } } } } });
};